import { getLogger } from '@cld/upload-widget-common';

const logger = getLogger();

export const READ_AS = {
  URL: 'DATA_URL', // default: data url
  BUFFER: 'ARRAY_BUFFER', // array buffer
};

export default () => {
  const files = [];
  const reader = new FileReader();

  let lastReadFileData = null;

  const onReadSuccess = () => {
    if (lastReadFileData) {
      // for flow :(
      lastReadFileData.readResolve({
        file: lastReadFileData.file,
        index: lastReadFileData.index,
        count: lastReadFileData.count,
        result: reader.result,
      });
    }

    handleReadFinish();
  };

  const handleReadFinish = () => {
    lastReadFileData = null;

    reader.removeEventListener('load', onReadSuccess, false);
    reader.removeEventListener('error', onReadError, false);

    if (files.length) {
      readFile(files.shift()); // continue to the next file
    }
  };

  const onReadError = () => {
    logger.log('[utils.fileReader]: failed to read file', reader.error);

    if (lastReadFileData) {
      // for flow :(
      lastReadFileData.readReject(reader.error);
    }

    handleReadFinish();
  };

  const readFile = (data) => {
    lastReadFileData = data;

    reader.addEventListener('load', onReadSuccess, false);
    reader.addEventListener('error', onReadError, false);

    if (data.readAs === READ_AS.BUFFER) {
      reader.readAsArrayBuffer(data.file);
    } else {
      reader.readAsDataURL(data.file);
    }
  };

  const read = (readAs, file, index = 0, count = 0) =>
    new Promise((resolve, reject) => {
      const readData = {
        file,
        index,
        count,
        readAs,
        readResolve: resolve,
        readReject: reject,
      };

      if (reader.readyState !== 1) {
        // if not already loading
        readFile(readData);
      } else {
        files.push(readData); // queue for later
      }
    });

  const readAsBuffer = (file, index = 0, count = 0) => read(READ_AS.BUFFER, file, index, count);

  const readAsUrl = (file, index = 0, count = 0) => read(READ_AS.URL, file, index, count);

  return {
    readAsUrl,
    readAsBuffer,
  };
};
